module.exports = __webpack_public_path__ + "img/deans-beans-logo_350x.05665295.webp";